import React, {useState, useRef} from 'react';
import AddNewRole from './AddNewRole';
import ViewRole from '../user-management/ViewRole.jsx'
import EditRole from '../user-management/EditRoles.jsx'
import {Dialog} from 'primereact/dialog';
import {ConfirmPopup} from 'primereact/confirmpopup';
import DataTableCard from '../../../../components/ui/DataTableCard';
import {useFetchList} from '../../../../hooks/useFetchList';

const RolesProfileReportTable = () => {
    const {rows: roles} = useFetchList('system/roles');
    const [activeRole, setActiveRole] = useState(null)
    const [dialogVisible, setDialogVisible] = useState(false);
    const [viewRole, setViewRole] = useState(false)
    const toast = useRef(null);

    const closeDialog = () => {
        setActiveRole(null);
        setDialogVisible(false);
        setViewRole(false);
    };

    const openRole = (rowData, view) => {
        setActiveRole(rowData);
        setViewRole(view);
        setDialogVisible(true);
    };

    const renderActions = (rowData) => (
        <div className="actions-container flex gap-2">
            <div className="tooltip" data-tip="View">
                <button
                    className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
                    onClick={() => openRole(rowData, true)}
                >
                    <i className="pi pi-eye text-lg"></i>
                </button>
            </div>
            <div className="tooltip" data-tip="Edit">
                <button
                    className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
                    onClick={() => openRole(rowData, false)}
                >
                    <i className="pi pi-pencil text-lg"></i>
                </button>
            </div>
        </div>
    );

    const handleCreateRole = async () => {
        setDialogVisible(false)

        await toast.current.show({severity: 'success', summary: 'Success', detail: 'User registered successfully'});
    }

    const columns = [
        {field: 'id', header: '#'},
        {field: 'name', header: 'Name'},
        {field: 'permissions.length', header: 'Permissions'},
        {field: 'actions', header: 'Actions', body: renderActions},
    ];

    const createButton = (
        <button className="btn btn-primary rounded-full btn-sm h-10" onClick={() => setDialogVisible(!dialogVisible)}>
            <i className="pi pi-user-plus"></i> Create New Role
        </button>
    );

    let dialog;
    if (activeRole === null) {
        dialog = (
            <Dialog header="Register new user" visible={dialogVisible} maximizable style={{width: '30vw'}} onHide={closeDialog}>
                <AddNewRole onCloseDialog={handleCreateRole}/>
            </Dialog>
        );
    } else if (viewRole) {
        dialog = (
            <Dialog header="View role" visible={dialogVisible} maximizable style={{width: '50vw'}} onHide={closeDialog}>
                <ViewRole roleData={activeRole} onCloseDialog={handleCreateRole}/>
            </Dialog>
        );
    } else {
        dialog = (
            <Dialog header="Edit role" visible={dialogVisible} maximizable style={{width: '30vw'}} onHide={closeDialog}>
                <EditRole roleData={activeRole} onCloseDialog={handleCreateRole}/>
            </Dialog>
        );
    }

    return (
        <DataTableCard
            title="User roles"
            exportName="User Roles"
            columns={columns}
            rows={roles}
            emptyMessage="No Roles found"
            toolbarExtras={createButton}
            exportDisabled={false}
        >
            <ConfirmPopup/>
            {dialog}
        </DataTableCard>
    );
};

export default RolesProfileReportTable;
